import { useNavigate } from 'react-router';
import { Button, EmptyState } from '../ui';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <EmptyState
      icon="search"
      title="This page doesn't exist."
      description="The link may be out of date, or the object it pointed at was deleted."
      action={
        <Button variant="secondary" onClick={() => void navigate('/')}>
          Open Home
        </Button>
      }
    />
  );
}
